import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as ExerciseActions from '../actions/exercise.actions';
import { ExerciceService } from '../../service/exercice.service';
import { ExerciceList } from '../../model/exerciceList.model';

@Injectable()
export class ExerciseEffects {

    constructor(
        private actions: Actions,
        private _exerciseService: ExerciceService,
    ) { }

    getExercise = createEffect(() => this.actions.pipe(
        ofType(ExerciseActions.GetExercise),
        exhaustMap(action => {
            return this._exerciseService.getExercices(action.params).pipe(
                map((exercises: ExerciceList) => {
                    return ExerciseActions.GetExerciseSuccess({ payload: exercises });
                }),
                catchError(() => of(ExerciseActions.GetExerciseFailure()))
            )
        })
    ));

    getDocumentFromUrl = createEffect(() => this.actions.pipe(
        ofType(ExerciseActions.GetExercisefromurl),
        exhaustMap(action => {
            return this._exerciseService.getExercicesByUrl(action.url).pipe(
                map((exercises: ExerciceList) => {
                    return ExerciseActions.GetExerciseSuccess({ payload: exercises });
                }),
                catchError(() => of(ExerciseActions.GetExerciseFailure()))
            )
        })
    ));
}

